__turbopack_context__.v({
  "actions": "packages-gallery-module__qLynBa__actions",
  "active": "packages-gallery-module__qLynBa__active",
  "body": "packages-gallery-module__qLynBa__body",
  "cityBadge": "packages-gallery-module__qLynBa__cityBadge",
  "cityBadges": "packages-gallery-module__qLynBa__cityBadges",
  "cityName": "packages-gallery-module__qLynBa__cityName",
  "cityNights": "packages-gallery-module__qLynBa__cityNights",
  "clearBtn": "packages-gallery-module__qLynBa__clearBtn",
  "durationBadge": "packages-gallery-module__qLynBa__durationBadge",
  "empty": "packages-gallery-module__qLynBa__empty",
  "emptyText": "packages-gallery-module__qLynBa__emptyText",
  "emptyTitle": "packages-gallery-module__qLynBa__emptyTitle",
  "fade": "packages-gallery-module__qLynBa__fade",
  "filterBar": "packages-gallery-module__qLynBa__filterBar",
  "filterField": "packages-gallery-module__qLynBa__filterField",
  "filterLabel": "packages-gallery-module__qLynBa__filterLabel",
  "filters": "packages-gallery-module__qLynBa__filters",
  "flyerBtn": "packages-gallery-module__qLynBa__flyerBtn",
  "footer": "packages-gallery-module__qLynBa__footer",
  "gpFade": "packages-gallery-module__qLynBa__gpFade",
  "grid": "packages-gallery-module__qLynBa__grid",
  "gridCard": "packages-gallery-module__qLynBa__gridCard",
  "headerRow": "packages-gallery-module__qLynBa__headerRow",
  "headerText": "packages-gallery-module__qLynBa__headerText",
  "media": "packages-gallery-module__qLynBa__media",
  "mediaLink": "packages-gallery-module__qLynBa__mediaLink",
  "price": "packages-gallery-module__qLynBa__price",
  "priceLabel": "packages-gallery-module__qLynBa__priceLabel",
  "priceValue": "packages-gallery-module__qLynBa__priceValue",
  "summary": "packages-gallery-module__qLynBa__summary",
  "switch": "packages-gallery-module__qLynBa__switch",
  "switchBtn": "packages-gallery-module__qLynBa__switchBtn",
  "title": "packages-gallery-module__qLynBa__title",
  "viewBtn": "packages-gallery-module__qLynBa__viewBtn",
});
